import React, {useEffect, useState} from 'react';
import {
    BrowseLabel,
    ContentWrapper,
    Headline,
    Label,
    TextWrapper,
    UploadImageWrapper
} from './UploadImageComponent.style';
import {DragAndDrop} from '../DragAndDrop/DragAndDrop';
import {Button} from '@bosch/react-frok';
import {t} from 'i18next';
import {config} from '../../init/config';
import {generateIdentifier} from '../../utils/IdentityUtils';

export interface UploadImageComponentProps {
    readonly existingImage: File | null;
    onChange: (imageFile: File | null) => void;
}

/**
 * @name UploadImageComponent
 * @description
 * A component to select an image to upload with preview functionality
 */
export const UploadImageComponent = (props: UploadImageComponentProps) => {
    const [image, setImage] = useState<File | null>(null);

    useEffect(() => {
        setImage(props.existingImage);
    }, [props.existingImage]);

    const handleImageFile = (imageFile: File | null) => {
        setImage(imageFile);
        props.onChange(imageFile);
    };

    const handleDelete = () => {
        setImage(null);
        props.onChange(null);
    };

    let selectFileId = generateIdentifier('select-file');

    return (
        <ContentWrapper id={generateIdentifier()}>
            <TextWrapper id={generateIdentifier()}>
                {t('UPLOAD_IMAGE_SIZE_INFO', {size: config.DLS_THUMBNAIL_MAX_SIZE})}
            </TextWrapper>
            <UploadImageWrapper id={generateIdentifier()}>
                <Headline id={generateIdentifier()}>
                    {(!image) ? (
                        <div id={generateIdentifier()}>
                            <input id={selectFileId}
                                   type='file'
                                   accept='image/*'
                                   style={{display: 'none'}}
                                   onChange={(e) => (e.target.files ? handleImageFile(e.target.files[0]) : null)}/>
                            <Label id={generateIdentifier()} htmlFor={selectFileId}>
                                <BrowseLabel id={generateIdentifier()} className='a-button a-button--secondary'>
                                    <i id={generateIdentifier()}
                                       className='a-icon a-button__icon boschicon-bosch-ic-folder-add'/>
                                    <div id={generateIdentifier()}
                                         className='a-button__label'>{t('UPLOAD_IMAGE_BROWSE')}</div>
                                </BrowseLabel>
                            </Label>
                        </div>
                    ) : (
                        <Button id={generateIdentifier()}
                                key='delete'
                                icon='delete'
                                mode='tertiary'
                                title={t('GENERAL_DELETE_LABEL')}
                                type='button'
                                onClick={handleDelete}/>
                    )}
                </Headline>
                {image ? (
                    <img id={generateIdentifier()}
                         style={{maxWidth: '100%', maxHeight: '100%'}}
                         src={URL.createObjectURL(image)} alt='Thumb'/>
                ) : (
                    <DragAndDrop browseFile={image}
                                 acceptImagesOnly={true}
                                 onChange={handleImageFile}/>
                )}
            </UploadImageWrapper>
        </ContentWrapper>
    );
};
